import { FC, memo } from 'react';
import LoadingSpin from '../LoadingSpin';
import { useAppStore } from '@/store';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';

export type CreditProps = {
  customValue?: number
  inline?: boolean;
  numColor?: string;
  postfixColor?: string;
};

const Credit: FC<CreditProps> = memo(({
  numColor = 'inherit',
  postfixColor = '#6ca776',
  ...props
}) => {
  const [t] = useTranslation(['common']);
  const creditValue = useAppStore(state => envConfig?.ui?.onlySubsidy ? state.subsidyCredit : state.credit);
  const loading = useAppStore(state => state.loadingCredit);

  if (loading) return <LoadingSpin className="inline-flex ms-2" text={null} size={14} />;

  const getValue = () => {
    let value = props.customValue;
    if (props.customValue == null) {
      value = creditValue;
    }
    if (value == null) {
      value = 0;
    }
    return Math.floor((value / 10)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <div
      style={{ gap: '0.125rem' }}
      className={`flex-center ${props.inline ? 'flex-row' : 'flex-col'}`}>
      <div className="text-base" style={{ color: numColor, direction: 'ltr' }}>{getValue()}</div>
      {envConfig.ui.removeCurrency ? <></> : <div className="text-center" style={{ color: postfixColor }}>{t('common:labels.tomans')}</div>}
    </div>
  );
});

export default Credit;
